import { h } from 'preact';
import Competitors from './competitors';
import CompanyInfo from './company-info';
import Description from './description';
import StockDetailsPage from '../stock-details-page';
import { FinanceSpinner } from '../glyphs';
import style from './style';
import cx from 'classnames';
import wire from 'wiretie';
import connect from '@cube/store-connect';
import { config } from '@os/finance-model';
import dlv from 'dlv';
import { compose } from '@cube/utils';
import { containerSize } from '@cube/blocks';

export const INTL_NS = 'company-profile';

export function Profile({ symbol, profileData, competitorStockData, locale, pending, width, ...props }){
	return (
		<StockDetailsPage symbol={symbol} {...props} class={cx(props.class, style.profile, width < 490 && style.narrow)}>
			{
				pending && pending.profileData ? <FinanceSpinner /> :
					<div>
						<CompanyInfo data={profileData} symbol={symbol} />
						<Competitors data={competitorStockData} pending={pending && pending.competitorStockData} symbol={symbol} />
						<Description
							data={profileData}
							hide={locale && dlv(config, 'limitedLocales', []).indexOf(locale) >=0}
						/>
					</div>
			}
		</StockDetailsPage>
	);
}

export default compose(
	wire('financeModel', ({ symbol }) => ({
		profileData: ['getProfile', symbol],
		competitorStockData: ['getCompetitorStockData', symbol]
	})),
	connect(({ locale }) => ({ locale })),
	containerSize({ height: false })
)(Profile);
